export default __webpack_public_path__ + "static/media/qr-arrow.3c4aa4c3.svg";